import axios from 'axios';

export const logisticsApi = axios.create({ baseURL: '/logistics-api' });
